<template>
  <div>
    <Head title="Crear Usuario" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-sky-400 hover:text-sky-600" href="/users">Usuarios</Link>
      <span class="text-sky-400 font-medium">/</span> Crear
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.first_name" :error="form.errors.first_name" class="pb-8 pr-6 w-full lg:w-1/2" label="Nombre (s)" />
          <text-input v-model="form.last_name" :error="form.errors.last_name" class="pb-8 pr-6 w-full lg:w-1/2" label="Apellidos" />
          <text-input v-model="form.email" :error="form.errors.email" class="pb-8 pr-6 w-full lg:w-1/2" label="Correo electrónico" />
          <text-input v-model="form.password" :error="form.errors.password" class="pb-8 pr-6 w-full lg:w-1/2" type="password" autocomplete="new-password" label="Contraseña" />
          <select-input v-model="form.rol" :error="form.errors.rol" class="pb-8 pr-6 w-full lg:w-1/2" label="Rol">
            <option v-for="rol in roles" :key="rol.id" :value="rol.id">{{ rol.rol }}</option>
          </select-input>
          <file-input v-model="form.photo" :error="form.errors.photo" class="pb-8 pr-6 w-full lg:w-1/2" type="file" accept="image/*" label="Photo" />
          <select-input v-if="showSelectTypeUser == true" v-model="form.type_user" :error="form.errors.type_user" class="pb-8 pr-6 w-full lg:w-1/2" label="Tipo de usuario">
            <option v-for="typeUser in typeUsers" :key="typeUser.id" :value="typeUser.id">{{ typeUser.type }}</option>
          </select-input>
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-sky" type="submit">Crear Usuario</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import FileInput from '@/Shared/FileInput'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    FileInput,
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
  },
  layout: Layout,
  props: {
    roles: Object,
    typeUsers: Object,
  }, 
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        rol: 0,
        photo: null,
        type_user: 0,
      }),
      showSelectTypeUser: true
    }
  },
  watch: {
  'form.rol': function(newVal, oldVal) {
    if (newVal == 3 || newVal == 5 || newVal == 6) {
      if(newVal == 5 || newVal == 6){
        this.form.type_user = 5;
      }else{
        this.form.type_user = newVal; // Asigna el valor de newVal a type_user
      }
      this.showSelectTypeUser = false;
    } else {
      this.showSelectTypeUser = true;
      this.form.type_user = 0;
    }
  }
  },
  methods: {
    store() {
      this.form.post('/users')
    },
  },
}
</script>
